import { snapshot } from 'stemi-firebase';

export const reducer = snapshot('carts', 'alwaysRefresh');

export { addOrderItem, removeOrderItem, updateOrderItem, removeAllOrderItems } from './actions';

export { default as middleware } from './middleware';
export { isCartEmpty, getDeSanitizedCart, getCart, sanitizeCart, roundToTwo } from './selectors';
